import LayerGroup from 'ol/layer/Group';

/**
 * A pseudo layer that merges some layers.
 * @extends {LayerGroup}
 */
export default class GeomodMergedLayer extends LayerGroup {
  /**
     * @constructor
     * @param {import("ol/layer/Group").Options} options The layers to merge.
     */
  constructor(options) {
    /** @type {Array<import("./GeomodTileLayer").default|import("./GeomodImageLayer").default>} */
    const { layers } = options;

    // Transfer title type to the mergedLayer.
    const additionnals = {
      title: layers[0].get('title'),
    };
    /*
         * Déplacement du type base des sous layers vers backuptype et ajout du type base pour le mergedLayer.
         * The type base indique au LayerSwitcher de la couche est une base et ne peut pas être activé en même
         * temps qu'une autre couche base.
         * Or la présense du type base dans les sous-layer provoquait la désactivation des sous couches base bien que
         * la mergedLayer soit active.
         * Le transfer vers backup existe au cas ou un nouveau mergedLayer soit créé, il faut qu'il puisse savoir qu'il
         * possède un couche base pour lui même devenir une base.
         */
    for (const layer of layers) {
      if (layer.get('type') === 'base' || layer.get('backuptype') === 'base') {
        additionnals.type = 'base';
      }
      if (layer.get('type') === 'base') {
        layer.unset('type');
      }
    }

    super({ ...options, filter: layers[0].get('filter'), ...additionnals });

    this.setVisible(layers[0].getVisible());
  }

  /**
     * @inheritdoc
     * Redefine method to get the same behavior than a {@link Layer}
     */
  /*
     * @Geomod Méthode nécassaire pour faire passer GeomodMergedLayer pour un layer.
     */
  getLayersArray(opt_array) {
    const array = opt_array || [];
    array.push(this);
    return array;
  }

  /**
     * Return layers include in merged layer.
     * @return {Array<import("./GeomodTileLayer").default|import("./GeomodImageLayer").default>}
     */
  getSubLayers() {
    return super.getLayersArray();
  }

  /**
     * Set the group and all merged layerd in the group visible.
     * @param {boolean} visible True if visible.
     */
  setVisible(visible) {
    super.setVisible(visible);
    for (const layer of this.getLayers().getArray()) {
      layer.setVisible(visible);
    }
  }

  /**
     * Add a parameter for the layer.
     * @param {string} paramName Parameter name.
     * @param {string} newValue Parameter value.
     */
  addParam(paramName, value) {
    for (const layer of this.getLayers().getArray()) {
      layer.addParam(paramName, value);
    }
  }

  /**
     * Update a parameter if it exists.
     * @param {string} paramName Parameter name.
     * @param {string} newValue Parameter value.
     */
  updateParam(paramName, newValue) {
    for (const layer of this.getLayers().getArray()) {
      layer.updateParam(paramName, newValue);
    }
  }

  /**
     * Remove a parameter if it exists.
     * @param {string} paramName Parameter name.
     */
  removeParam(paramName) {
    for (const layer of this.getLayers().getArray()) {
      layer.removeParam(paramName);
    }
  }

  /**
     * Refresh the layer by requesting a new image in server.
     */
  refresh() {
    for (const layer of this.getLayers().getArray()) {
      layer.refresh();
    }
  }

  /**
     * Get the layer name.
     * @returns {string} the layers name
     */
  getName() {
    // Le nom d'une couche fusionnée devient l'indentifiant de fusion plutôt que le nom des couches combiné.
    return this.getLayers().getArray()[0].get('merge');
  }

  /**
     * Get the layer tag.
     * @return {string} the layers tag
     */
  getTag() {
    return this.getLayers().getArray()[0].getTag();
  }
}
